export const logEvent = async (category, title) => {
  const url = 'https://apigateway.commerce7.com/lambdas/analytic/update';

  await fetch(url, {
    method: 'post',
    keepalive: true,
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ category, title })
  });
};
